import { settlementConstants } from '../constants/actionTypes'

let initialState = {
  isValid: false,
  agreementId: '',
  recipients: [],
  isFetching: false,
}

export const settlement = (
  state = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case settlementConstants.FETCH_SETTLEMENT_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case settlementConstants.FETCH_SETTLEMENT_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      }

    default:
      return state
  }
}
